import script from "./Firmendokumente.vue?vue&type=script&setup=true&lang=js"
export * from "./Firmendokumente.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__